import { AccountEvent } from '@/api/spec';
import type { AccountHistoryEvent } from '@/feature/terminal_tables/account_history/AccountEvent.ts';
import { amountToBig } from '@/utils/bigUtils.ts';
import { generateBlockLogId } from '@/utils/generateBlockLogId.ts';

export function mapAccountEventsToHistory(
  accountEvents: AccountEvent[],
  collateralDecimals: number = 6
): AccountHistoryEvent[] {
  return accountEvents
    .map((event: AccountEvent): AccountHistoryEvent | undefined => {
      if (!event.at.t) {
        return undefined;
      }

      const amount = amountToBig(event.a, collateralDecimals);
      if (amount.eq(0)) {
        return undefined;
      }

      const updatedBalance = amountToBig(event.b, collateralDecimals);
      const fee = amountToBig(event.f, collateralDecimals);

      return {
        id: generateBlockLogId(event.at),
        dateTimestamp: event.at.t,
        txHash: event.at?.txid,
        eventType: event.et,
        amount: amount.toNumber(),
        updatedBalance: updatedBalance.toNumber(),
        fee: fee.toNumber(),
        marketId: event.m,
        orderId: event.o,
        requestId: event.r,
        positionId: event.p,
      };
    })
    .filter((event): event is AccountHistoryEvent => event != null);
}
